export default {
  space: '6px',
  spaceArrow: '10px',
  arrowOffset: '10px',
  arrowOffsetVertical: '10px',
  arrowHeight: '6px',
  padding: '8px 14px'
}
